export default {
  initAMap: function () {
    const AMap_URL =
      "https://webapi.amap.com/maps?v=2.0&key=9488417fef1200014ecebdfd13c5bdbb&plugin=AMap.Geocoder&callback=onAMapLoaded";
    return new Promise((resolve, reject) => {
      // 如果已加载直接返回
      if (typeof AMap !== "undefined") {
        resolve(AMap);
      }
      // 高德地图异步加载回调处理
      window.onAMapLoaded = function () {
        resolve(AMap);
      };
      // 安全密钥
      window._AMapSecurityConfig = {
        securityJsCode: "f1916042e0f555183d8be3e03ea8ba9a",
      }
      // 插入script脚本
      let scriptNode = document.createElement("script");
      scriptNode.setAttribute("type", "text/javascript");
      scriptNode.setAttribute("src", AMap_URL);
      scriptNode.setAttribute("async", "true");
      //   scriptNode.setAttribute("onerror", reject);
      document.head.appendChild(scriptNode);
    });
  },
};
